<template>
<v-dialog v-model="dialogShowQRCode" persistent max-width="500px">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
          <span class="headline CSChatThai">
            <v-icon color="white">fas fa-qrcode</v-icon>&nbsp;&nbsp;{{$t('Settings.Qrcode.header')}}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12>
            <h3 class="header">{{$t('Settings.editProfile.qrcodeForAddFriend')}}</h3>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12>
            <div>
              <!-- <p >QR code</p>  -->
              <p style="justify-content: center; display: flex;">
                <qrcode :value="tokenuserQR" style="width: 150px; height: 150px;" id="downloadqr"></qrcode>
              </p>
              <p>{{$t('Settings.editProfile.detailQRcode')}}
                <a href="#" class="button" id="btn-download" :download="'qrcode_user_' + name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
// import { mapState } from 'vuex'
// var _ = require('lodash')
import Vue from 'vue'
import {
  Decode
} from '@/services'
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)

export default {
  props: {
    'dialogShowQRCode': false
  },
  data: () => ({
    token: '',
    name: '',
    tokenuserQR: ''
  }),
  methods: {
    closeDialog() {
      this.$emit('closeShowQRCodeUser', false)
    },
    loadqr() {
      var cnvs = document.getElementById('downloadqr')
      var button = document.getElementById('btn-download')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    }
  },
  computed: {},
  created() {
    this.name = localStorage.getItem('name')
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(this.$cookie.get('tokenuser'))
    this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.token)
  }
}
</script>
<style type="text/css" scoped>
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

/*.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
  color: #5ed1ff !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/QrcodeuserDialogMobile.vue